"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var SmileyEnjoyFill = function SmileyEnjoyFill(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "SmileyEnjoyFill"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.48567 0 0 4.486 0 10C0 15.514 4.48567 20 10 20C15.5143 20 20 15.514 20 10C20 4.486 15.5143 0 10 0ZM5.661 5.492C6.127 5.42667 6.54167 5.65433 6.77367 6.03133C6.89267 5.605 7.25433 5.268 7.721 5.20233C8.349 5.114 8.874 5.56933 9.018 6.18033C9.018 6.18033 9.07067 6.32967 9.04234 6.616C9.00301 7.005 8.83366 7.36967 8.57833 7.66633L7.22133 9.213L5.517 8.09633C5.189 7.88167 4.92566 7.57767 4.78133 7.214C4.67433 6.94733 4.684 6.78967 4.684 6.78967C4.653 6.16267 5.03233 5.58033 5.661 5.492ZM10 16.9167C7.15133 16.9167 4.65267 14.418 4.65267 11.5693C4.65267 11.1477 4.994 10.8053 5.41667 10.8053C5.83933 10.8053 6.18066 11.1477 6.18066 11.5693C6.18066 13.5683 8.001 15.3887 10 15.3887C11.999 15.3887 13.8193 13.5683 13.8193 11.5693C13.8193 11.1477 14.1607 10.8053 14.5833 10.8053C15.006 10.8053 15.3473 11.1477 15.3473 11.5693C15.3473 14.418 12.8487 16.9167 10 16.9167ZM15.2513 7.259C15.1 7.61933 14.8313 7.91867 14.5003 8.12767L12.7503 9.21L11.447 7.644C11.196 7.34267 11.0333 6.97533 11.0013 6.585C10.977 6.299 11.0323 6.15067 11.0323 6.15067C11.1867 5.54233 11.7197 5.09633 12.3467 5.19567C12.8113 5.26933 13.1413 5.60833 13.253 6.03667C13.4913 5.66367 13.9357 5.447 14.4013 5.521C15.0277 5.62033 15.3967 6.20933 15.3557 6.83533C15.3557 6.83533 15.3623 6.99333 15.2513 7.259Z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = SmileyEnjoyFill;
exports["default"] = _default;